"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CloseGraphicsEditorButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _i18n = require("../../../../../Framework/i18n");
var _MainButton = _interopRequireDefault(require("../../../../../Shared/Components/MainButton"));
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _button;
  return {
    button: (_button = {
      pointerEvents: 'all'
    }, _defineProperty(_button, theme.breakpoints.up('sm'), {
      marginBottom: 16,
      minHeight: 40
    }), _defineProperty(_button, theme.breakpoints.down('xs'), {
      height: 56
    }), _button)
  };
};
var CloseGraphicsEditorButton = exports.CloseGraphicsEditorButton = (0, _styles.withStyles)(styles, {
  name: 'CloseGraphicsEditorButton'
})(function (_ref) {
  var closeDesignArea = _ref.closeDesignArea,
    classes = _ref.classes;
  return /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
    onClick: closeDesignArea,
    size: "medium",
    fullWidth: true,
    variant: "contained",
    className: (0, _clsx["default"])(classes.button, (0, _customClassName["default"])('open-editor-button'))
  }, (0, _i18n.t)('designAreaControlBox.backToProductView'));
});
var _default = exports["default"] = CloseGraphicsEditorButton;